/*
 * Commercial Journey Components
 */
import SelectApplicationType from "@tenant/commercial-journey/SelectApplicationType.vue"
import FormSteps from "@tenant/commercial-journey/FormSteps.vue"


const CommercialJourney = {
    SelectApplicationType,
    FormSteps
}

export default {
  ...CommercialJourney
}
